// extracted by mini-css-extract-plugin
var _1 = "wrzLafLdD9r8KGdjbwLy";
export { _1 as "root" }
